<template>
  <div id="app" :route="$route.name">
    <div class="app-container">
      <app-header v-if="showHeader"></app-header>
      <router-view/>
      <banner-contacto v-if="showHeader"></banner-contacto>
      <app-footer v-if="$route.name != 'firma-contrato'"></app-footer>
    </div>
    <banner-home-llamamos></banner-home-llamamos>

    <!-- <div class="cover-popup -intro row-center" v-if="showbanner">
      <div class="popup">
        <a class="cerrar" @click="showbanner = false">✕</a>
        <router-link @click.native="showbanner = false" :to="$t('enlaces.autoconsumo_ayudamos')"><img src="/static/img/autoconsumo/banner-placas.webp" alt="Banner placas"></router-link>
      </div>
    </div> -->

  </div>
</template>

<script>

  import header from '@/components/parts/header'
  import footer from '@/components/parts/footer'
  import bannerContacto from '@/components/parts/banner-contacto';

  const bannerLlamamos = () => import('@/components/parts/banner-home-llamamos');


  import popupError from '@/components/parts/popup-error';

  import {mapActions} from 'vuex';

  export default {
    name: 'App',
    components : {
      'app-header' : header,
      'app-footer' : footer,
      'banner-contacto' : bannerContacto,
      'popup-error' : popupError,
      'banner-home-llamamos' : bannerLlamamos,
    },
    mounted(){
      
      if(!window.sessionStorage.getItem('banner')){
        this.showbanner = true;
        window.sessionStorage.setItem('banner',true)
      }

      if(location.origin == 'http://inerenergia.es'){
       location.href = 'https://'+location.hostname+location.pathname; 
      }

    },
    data(){
      return{
        acepted : Boolean(window.localStorage.getItem('cookie:accepted')),
        showbanner : false
      }
    },
    methods : {
      ...mapActions(['requestPrecios','requestPreciosEmpresa']),
      setacepted(){
        this.acepted = true;
      }
    },
    computed:{
      showHeader(){
        let hideIN = ['contrato-firmado','firma-contrato','inergizate','contrato-solicitado','landingautoconsumo'];
        let show = (!hideIN.some(e => e == this.$route.name));
        return show;
      },
      
    },
    watch: {
      '$route': {
        handler: function (route) {
          if (route.name && route.name !== 'blog' && route.name !== 'blog-ficha') {
            this.requestPrecios();
            this.requestPreciosEmpresa();
          }
        },
        deep: true,
        immediate: true
      }
    }
  }
</script>

<style  lang="scss">
  @import '@/assets/css/colors.scss';
  @import './assets/css/style.scss';
  @import './assets/css/responsive.scss';
  @import './assets/css/slick.css';
  @import url('https://fonts.googleapis.com/css?family=Titillium+Web:300,400,400i,700&display=swa');
  @import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css);
  @import url(https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.5.2/animate.min.css);
  


  
</style>



// WEBPACK FOOTER //
// src/App.vue